import { Modal, Table } from "antd";
import { memo } from "react";
import { useSelector } from "react-redux";

const columns = [
  {
    title: "Sr. No.",
    dataIndex: "srNo",
    key: "srNo",
    render: (text, data, index) => index + 1,
  },
  {
    title: "From Date",
    dataIndex: "from_date",
    key: "from_date",
  },
  {
    title: "To Date",
    dataIndex: "to_date",
    key: "to_date",
  },
  {
    title: "Medicine",
    dataIndex: "medicine",
    key: "medicine",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Dose",
    dataIndex: "dose",
    key: "dose",
  },
];
const LutealPhaseModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Luteal Phase Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        {" "}
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Partner Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Patient Details</div>
              <div className="details-table">
                <div>IVF ID</div>
                <div>{activePatientJourneyModuleDetails?.ivf_flow_id}</div>
                <div>Last Menstrual Period</div>
                <div>
                  {activePatientJourneyModuleDetails?.last_menstrual_period}
                </div>
                <div>Factors</div>
                <div>{activePatientJourneyModuleDetails?.factors}</div>
                <div>Protocol</div>
                <div>{activePatientJourneyModuleDetails?.protocol}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Medicine Details</div>
              <div className="details-table">
                {/* <div>From Date</div>
              <div>{activePatientJourneyModuleDetails?.from_date}</div>
              <div>To Date</div>
              <div>{activePatientJourneyModuleDetails?.to_date}</div>
              <div>Medicine</div>
              <div>{activePatientJourneyModuleDetails?.medicine}</div>
              <div>Category</div>
              <div>{activePatientJourneyModuleDetails?.category}</div>
              <div>Dose</div>
              <div>{activePatientJourneyModuleDetails?.dose}</div> */}
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <h3 className="mt-3">Medicine Details</h3>
            <Table
              columns={columns}
              dataSource={activePatientJourneyModuleDetails?.medicine_detail}
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default memo(LutealPhaseModal);
